import { render, staticRenderFns } from "./TransactionTags.vue?vue&type=template&id=dbf814e6&"
import script from "./TransactionTags.vue?vue&type=script&lang=js&"
export * from "./TransactionTags.vue?vue&type=script&lang=js&"
import style0 from "./TransactionTags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports